import ApproveCommissionPayment from './ApproveCommissionPayment';
import UpdateBulkEmployeesSalary from './UpdateBulkEmployeesSalary';
import TerminateBulkEmployees from './TerminateBulkEmployees';
import UploadCommissionSheet from './UploadCommissionSheet';
import SpecificEmployee from './SpecificEmployee';
import AddBulkEmployees from './AddBulkEmployees';
import ViewDepartments from './ViewDepartments';
import ViewEmployees from './ViewEmployees';
import EditEmployee from './EditEmployee';
import AddEmployee from './AddEmployee';
import ViewGroups from './ViewGroups';
import Employees from './Employees';
import AddLoan from './AddLoan';
import CommisionTable from './CommisionTable';

export {
	Employees,
	ViewEmployees,
	AddEmployee,
	SpecificEmployee,
	EditEmployee,
	ViewDepartments,
	AddBulkEmployees,
	TerminateBulkEmployees,
	UpdateBulkEmployeesSalary,
	ViewGroups,
	AddLoan,
	UploadCommissionSheet,
	ApproveCommissionPayment,
	CommisionTable,
};
